import { Icon } from '../../UI';

import { getLogo } from '../../../helpers/functions';

import { TTickerCurrency } from '../../../types/model';
import { IStrategyAsset } from '../../../types/model';
import { CustomNumber } from '../../CustomNumber/CustomNumber';
import { PORTFOLIO_COLUMNS } from './Portfolio';

export const AssetDetail = ({
  currency,
  asset: {
    asset: { logo, type: assetType, name: assetName, history },
    entryPrice,
    id,
    name,
    unit,
  },
  onChange,
  goBack,
}: {
  asset: IStrategyAsset;
  currency: TTickerCurrency;
  onChange(s: any, originalValue: number): void;
  goBack?(): void;
}) => {
  const lastPrice = history[0][currency];
  const WrapperDetail = ({ children }: { children: JSX.Element[] }) => (
    <div className="flex flex-col my-4 gap-2">{children}</div>
  );
  const WrapperDescription = ({ children }: { children: string }) => (
    <span className="flex capitalize-first font-medium text-sm">
      {children}
    </span>
  );
  const values = [
    unit,
    entryPrice,
    currency.toLocaleUpperCase(),
    lastPrice,
    666,
    666,
    666,
    666,
    666,
    lastPrice * unit,
    '999', //%
  ];

  return (
    <div
      className={`
        flex
        flex-col
        h-auto
      `}
    >
      {/* HEADER */}
      <div
        className={`
          flex
          sticky
          top-0
          bg-white
          items-center
          border-b
          border-grey-10
          pb-2
          pl-5
          -mt-2
        `}
      >
        <Icon
          svgName="arrowBack"
          className="h-4 w-4 cursor-pointer"
          onClick={goBack}
        />
        <img
          className="h-7 w-7 mx-4"
          src={getLogo(assetType!, logo)}
          alt={assetName}
        />
        <div className="flex flex-col">
          <span className="font-semibold">{name}</span>
          <span className="text-grey-50 text-xs">{assetName}</span>
        </div>
      </div>

      {/* DETAILS */}
      <div className="flex flex-col overflow-y-scroll pl-5 mt-3">
        {[...PORTFOLIO_COLUMNS.slice(1)].map((description, i) => (
          <WrapperDetail key={`assetDetail_${i}`}>
            <WrapperDescription>{description}</WrapperDescription>
            {!isNaN(+values[i]) ? (
              <CustomNumber
                className="cursor-default text-grey"
                id={id}
                name={!i ? 'unit' : 'entryPrice'}
                value={+values[i]}
                onKeyDown={(e) => onChange(e, +values[i])}
              />
            ) : (
              <span className="flex text-grey">{values[i]}</span>
            )}
          </WrapperDetail>
        ))}
      </div>
    </div>
  );
};
